import {SxType} from '@baseTypes/sx/sxTypes'

export default {
	main: {
		flex: 1,
		minWidth: 0,
		height: '100%',
		overflow: 'auto',
		p: 2,
	},
	header: {
		display: 'flex',
		alignItems: 'baseline',
		flexWrap: 'wrap',
		gap: '10px',
		mb: 1.5,
	},
	title: {
		fontSize: '18px',
		fontWeight: 700,
	},
	subtitle: {
		fontSize: '13px',
		color: 'text.secondary',
	},
	hint: {
		fontSize: '13px',
		color: 'text.secondary',
		mb: 1,
	},
	chip: {
		minWidth: 0,
		padding: '2px 10px',
		fontSize: '12px',
		textTransform: 'none',
		borderRadius: '8px',
	},
} as const satisfies SxType
